var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Select',{attrs:{"filterable":"","placeholder":"请选择分类","clearable":""},on:{"on-change":_vm.change},model:{value:(_vm.sel),callback:function ($$v) {_vm.sel=$$v},expression:"sel"}},_vm._l((_vm.list),function(item){return _c('Option',{attrs:{"label":item.name,"value":item.id}})}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64360bad","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ziliao/common/FenleiSelect.vue
// module id = null
// module chunks = 